import { localeNames } from 'common/constants/localeTypes'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import { LocalesOptionType } from '..'

export function getLocalesOptions(params: {
  localeList?: PageLocaleEnum[]
  setAdditionalProperties?: undefined
  t: TFunction
}): LocalesOptionType[]

export function getLocalesOptions<
  AdditionalProperties extends Record<string, unknown>,
>(params: {
  localeList?: PageLocaleEnum[]
  setAdditionalProperties: (language: PageLocaleEnum) => AdditionalProperties
  t: TFunction
}): Array<LocalesOptionType & AdditionalProperties>

export function getLocalesOptions<
  AdditionalProperties extends Record<string, unknown>,
>({
  localeList = Object.values(PageLocaleEnum),
  setAdditionalProperties,
  t,
}: {
  localeList?: PageLocaleEnum[]
  setAdditionalProperties?: (language: PageLocaleEnum) => AdditionalProperties
  t: TFunction
}): LocalesOptionType[] | Array<LocalesOptionType & AdditionalProperties> {
  return localeList.map(language => ({
    value: language,
    label: t(localeNames[language]),
    ...(setAdditionalProperties ? setAdditionalProperties(language) : {}),
  }))
}
